module.exports = __webpack_public_path__ + "7ae7969c0e6bcd374cab2c62d7fc40e8.glb";